import { createContext, useContext, type ReactNode } from 'react';
import { useCookieConsent } from '../hooks/useCookieConsent';
import type { ConsentStatus } from '../hooks/useCookieConsent';

interface CookieConsentContextValue {
  status: ConsentStatus;
  accept: () => void;
  reject: () => void;
  revoke: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);

export const CookieConsentProvider = ({ children }: { children: ReactNode }) => {
  const consent = useCookieConsent();
  return (
    <CookieConsentContext.Provider value={consent}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsentContext = () => {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error('useCookieConsentContext must be used within CookieConsentProvider');
  return ctx;
};
